import type { User } from "@supabase/supabase-js";

/** FIX-260: invited users must set a password before using the app. */
export function needsInvitePassword(user: Pick<User, "invited_at" | "user_metadata"> | null): boolean {
  if (!user || !user.invited_at) return false;
  return user.user_metadata?.password_set !== true;
}

/** Captured at module load, before supabase-js strips the URL hash. */
export function detectInviteMode(search: string, hash: string): boolean {
  return new URLSearchParams(search).get("mode") === "invite" || /(^|[#&])type=invite(&|$)/.test(hash);
}
